import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { ContactHeroSection } from '@trashlab/sitesapp/src/templates/redebins/components/contact/contact-hero-section';
import { ContactContent } from '@trashlab/sitesapp/src/templates/redebins/components/contact/contact-content';
import { ReadyWhenYouAre } from '@trashlab/sitesapp/src/templates/redebins/components/shared/ready-when-you-are';
import { ServiceAreasSection } from '@trashlab/sitesapp/src/templates/redebins/components/shared/service-areas-section';

const ContactPage = () => {
  return (
    <>
      <ContactHeroSection />
      <ContactContent />
      <ReadyWhenYouAre />
      <ServiceAreasSection />
    </>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/contact',
  component: ContactPage,
});

